/* eslint-disable id-length,no-unused-vars */
import { TweenLite, Power4 } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export const easing = '0.25, 0.46, 0.45, 0.94'

export const fadeIn = (utils) =>
  TweenLite.fromTo(utils.target, 0.2, { opacity: 0 }, { ease: Power4.easeOut, opacity: 1 })
